













































import { Component, Vue, Prop } from "vue-property-decorator";
import { getWenlitezheng } from "@/request/idr";
@Component({})
export default class IdrTongueBiaozhuYanse extends Vue {
  @Prop()
  private tongueId: any;
  private loaded: boolean = false;
  private filters: any = {
    类别: "苔质"
  };
  private message: any = {};
  private th: any[] = [];
  private tr: any[] = [];
  /**
   * @description 获得纹理特征
   */
  private fetchWenli() {
    const params: any = {
      params: {
        tongue_id: this.tongueId,
        类别: this.filters["类别"]
      }
    };
    getWenlitezheng(this, params).then((data: any) => {
      this.message = data;
      this.th = this.message["详细参数列表"].splice(0, 1)[0];
      this.tr = this.message["详细参数列表"];
    });
  }
  /**
   * @description 改变类别
   */
  private changeLeilie(leibie) {
    this.filters["类别"] = leibie;
    this.loaded = false;
    this.fetchWenli();
  }
  /**
   * @description 初始化
   */
  private mounted() {
    if (this.tongueId) {
      this.fetchWenli();
    }
  }
}
